import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { useEffect } from 'react';
import { estErreurChunkManquant, marquerRechargementTente, rechargementDejaTente } from '../lib/chunk-reload';

export default function NotFoundRoute(): JSX.Element {
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const message = isRouteErrorResponse(error)
    ? error.statusText || error.data
    : error instanceof Error
      ? error.message
      : 'Page introuvable';

  // Auto-récupération après déploiement (stack Ben 17/08, cf.
  // `lib/chunk-reload.ts`) : un chunk manquant en navigation douce se
  // résout par UN rechargement complet vers la même URL — l'index HTML frais
  // pointe déjà vers les bons hashes. Anti-boucle : si ça retombe sur la
  // même erreur après coup, on abandonne et affiche l'écran normal.
  const chunkManquant = !is404 && estErreurChunkManquant(error);
  const rechargementEnCours = chunkManquant && !rechargementDejaTente();

  useEffect(() => {
    if (!rechargementEnCours) return;
    marquerRechargementTente();
    window.location.reload();
  }, [rechargementEnCours]);

  if (rechargementEnCours) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" role="status" aria-live="polite">
        <span className="text-sm text-slate-400">Mise à jour disponible, rechargement…</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="text-6xl font-bold text-slate-200">{is404 ? '404' : 'Oops'}</div>
        <h1 className="mt-4 text-xl font-semibold text-slate-900">
          {is404 ? 'Page introuvable' : 'Erreur de navigation'}
        </h1>
        <p className="mt-2 text-sm text-slate-600">{String(message)}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg bg-[var(--accent)] text-white hover:opacity-90"
        >
          Retour au tableau de bord
        </Link>
      </div>
    </div>
  );
}
